import React from "react";
import { get } from "lodash";
import { PropTypes } from "prop-types";
import styles from "./styles.m.css";
import { Icon } from "../../atoms/icon";
import { DeepBI, GA } from "../../../integrations";
class AudioPlayer extends React.Component {
  state = {
    playing: false,
    currentTime: 0,
    duration: 0,
    volume: 1,
    shouldRender: false
  };

  audioRef = React.createRef();

  componentDidMount() {
    const { story } = this.props;
    //  const storyId = get(story, ["id"], null);

    if (
      story["published-at"] >= 1680393599000 &&
      (story["story-template"] === "text" || story["story-template"] === "syndicated")
    ) {
      this.setState({ shouldRender: true });
    }

    // global
    //   .fetch(`https://image.vikatan.com/audio/${storyId}.mp3`)
    //   .then(response => {
    //     if (response.status === 200) {
    //       console.log("File exists");
    //       this.setState({
    //         AudioAvailable: true
    //       });
    //     } else {
    //       this.setState({
    //         AudioAvailable: false
    //       });
    //       console.log("File does not exist");
    //     }
    //   })
    //   .catch(error => {
    //     console.error("Error checking file existence:", error);
    //   });
  }

  handlePlay = () => {
    this.audioRef.current.play();
    this.setState({ playing: true, currentTime: this.audioRef.current.currentTime });

    let currentTime = this.state.currentTime;
    DeepBI.PingAudioplayer(
      this.props.story,
      currentTime > 0 ? "audioresumed" : "audioplayed",
      this.formatSecondsTime(this.state.currentTime),
      this.formatSecondsTime(this.audioRef.current.duration)
    );
    GA.customEvent("player", currentTime > 0 ? "audioresumed" : "audioplayed", this.props.story);
    if (global.webengage && global.webengage.track) {
      global.webengage.track(currentTime > 0 ? "audioresumed" : "audioplayed", {});
    }
  };

  handlePause = () => {
    this.audioRef.current.pause();
    this.setState({ playing: false, currentTime: this.audioRef.current.currentTime });
    DeepBI.PingAudioplayer(
      this.props.story,
      "audiopaused",
      this.formatSecondsTime(this.state.currentTime),
      this.formatSecondsTime(this.audioRef.current.duration)
    );
    GA.customEvent("player", "audiopaused", this.props.story);
    if (global.webengage && global.webengage.track) {
      global.webengage.track("audiopaused", {});
    }
  };

  handleTimeUpdate = () => {
    this.setState({
      currentTime: this.audioRef.current.currentTime,
      duration: this.audioRef.current.duration
    });
  };

  setFinished = () => {
    this.setState({
      playing: false,
      currentTime: 0
    });
    DeepBI.PingAudioplayer(
      this.props.story,
      "audiocompleted",
      this.formatSecondsTime(this.state.currentTime),
      this.formatSecondsTime(this.audioRef.current.duration)
    );
    GA.customEvent("player", "audiocompleted", this.props.story);
    if (global.webengage && global.webengage.track) {
      global.webengage.track("audiocompleted", {});
    }
  };
  handleVolumeChange = e => {
    this.setState({ volume: e.target.value });
    this.audioRef.current.volume = e.target.value;
  };

  handleSeek = e => {
    this.audioRef.current.currentTime = e.target.value;
  };

  formatTime = time => {
    const remainder = time % 3600;
    const minutes = Math.floor(remainder / 60);
    const seconds = Math.floor(remainder % 60);

    const mm = minutes.toString().padStart(2, "0");
    const ss = seconds.toString().padStart(2, "0");

    return `${mm}:${ss}`;
  };

  formatSecondsTime = time => {
    const remainder = time % 3600;
    const minutes = Math.floor(remainder / 60);
    const seconds = Math.floor(remainder % 60);

    const mm = minutes.toString().padStart(2, "0");
    const ss = seconds.toString().padStart(2, "0");

    return parseInt(mm) * 60 + parseInt(ss);
  };

  skip = time => {
    if (time === "back") {
      this.audioRef.current.currentTime = this.audioRef.current.currentTime - 15;
    } else if (time === "fwd") {
      this.audioRef.current.currentTime = this.audioRef.current.currentTime + 15;
    }
  };

  render() {
    const {
      playing,
      currentTime,
      duration
      // AudioAvailable
    } = this.state;

    const { story } = this.props;
    const storyId = get(story, ["id"], null);
    if (!this.state.shouldRender) {
      return null;
    }

    return (
      <div className={styles["audio-player-wrapper"]}>
        <p className={`${styles["speaker-wrapper"]}`}>
          <Icon type="speakeraudio" className={`${styles["speakeraudio"]}`} />
          இந்தக் கட்டுரையை ஆடியோவில் கேட்க
        </p>
        <div className={styles["audio-controls"]}>
          <audio
            ref={this.audioRef}
            src={`https://image.vikatan.com/audio/${storyId}.mp3`}
            onTimeUpdate={this.handleTimeUpdate}
            onEnded={this.setFinished}
            preload="none"
          />
          <div className={styles["audio-controls-grid"]}>
            <div className={styles["audio-text"]}>{this.formatTime(currentTime)}</div>

            <div className={styles["progress-bar"]}>
              <input
                type="range"
                min={0}
                max={duration}
                step={0.01}
                value={currentTime}
                onChange={this.handleSeek}
                className={styles["progress"]}
              />
            </div>

            <div
              onClick={() => this.skip("back")}
              className={`${styles["fast-backward-outer"]} ${styles["audio-control-icons"]}`}
            >
              <Icon type="backward" className={`${styles["fast-backward"]} ${styles["audio-icon"]}`} />
            </div>
            <div className={`${styles["audio-control-icons"]}`} onClick={playing ? this.handlePause : this.handlePlay}>
              {playing ? (
                <Icon type="pause" className={`${styles["pause"]} ${styles["audio-icon"]}`} />
              ) : (
                <Icon type="play" className={`${styles["play"]} ${styles["audio-icon"]}`} />
              )}
            </div>
            <div
              onClick={() => this.skip("fwd")}
              className={`${styles["fast-forward-outer"]} ${styles["audio-control-icons"]}`}
            >
              <Icon type="forward" className={`${styles["fast-forward"]} ${styles["audio-icon"]}`} />
            </div>
            {/* <div>
            <input type="range" min={0} max={1} step={0.01} value={volume} onChange={this.handleVolumeChange} />
          </div> */}
          </div>
          <div className={styles["audio-text"]}>{this.formatTime(duration)}</div>
        </div>
      </div>
    );
  }
}

AudioPlayer.propTypes = {
  story: PropTypes.object
};

export default AudioPlayer;
